import React from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import { compose, withHandlers, withProps } from "recompose";

export const EditDeleteButtons = ({
  editProps,
  deleteProps,
  url,
  id,
  wrapOnDelete,
  allowDelete,
  readOnly,
  showDelete = true,
  showUndelete = false,
  editable = true,
  wrapOnUndelete,
  deleteText,
}) =>
  readOnly ? (
    <span>
      <Link
        className="btn btn-primary btn-sm mr-1"
        to={`${url}/${id}`}
        {...editProps}
      >
        <span className="fa fa-eye" />
      </Link>
    </span>
  ) : (
    <span id={`organisation-edit-${id}`}>
        {editable && <Link
        className="btn btn-primary btn-sm mr-1 fix-bg-edit-btn"
        style={{borderRadius:"6px",backgroundColor: "rgb(114, 181, 102)", borderColor:"rgb(114, 181, 102)"}}
        to={`${url}/${id}`}
        {...editProps}
      >
        <span className="fa fa-edit" style={{fontSize:"15px"}}/>
      </Link>
      }
      {allowDelete && showDelete && (
        <Button style={{borderRadius:"6px",backgroundColor: "rgb(252, 102, 102)", borderColor:"rgb(252, 102, 102)"}}
          color="danger"
          size="sm"
          {...deleteProps}
          onClick={wrapOnDelete}
        >
          {deleteText ? deleteText : <span className="fa fa-trash" style={{fontSize:"15px"}}/>}
        </Button>
      )}

      {
        showUndelete && (
          <Button style={{borderRadius:"6px", backgroundColor: "rgb(114, 181, 102)", borderColor:"rgb(114, 181, 102)"}}
            color="danger"
            size="sm"
            {...deleteProps}
            onClick={wrapOnUndelete}
            title="Click to Unarchive"
          >
            <span className="fa fa-undo" style={{fontSize:"15px"}}/>
          </Button>
        )
      }
    </span>
  );

const enhance = compose(
  withProps(({ onDelete }) => ({
    allowDelete: !!onDelete,
  })),
  withHandlers({
    wrapOnDelete:
      ({ id, onDelete }) =>
      () =>
        onDelete(id),
    
    wrapOnUndelete:
      ({ id, onUndelete }) =>
      () =>
        onUndelete(id),
  })
);

export default enhance(EditDeleteButtons);
